export default "__VITE_ASSET__BrCqNEIV__"